@if (loading() || hasNavigableLinks()) {
  <fin-ond-marketing-link-list
    [heading]="cityToCityHeading()"
    [headingLevel]="type() === OndCrossLinkingType.CITY_TO_CITY_LANDING ? 1 : 2"
    labelKey="ondMarketing.fromTo"
    [groups]="mappedGroups()"
    [loading]="loading()"
  />
}
